/**
 * Stores build information. The string literals are replaced at compile time by `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-08-31",
    versionChannel: "nightly",
    buildDate: "2024-08-31T00:05:26.054Z",
    commitHash: "2fd8f600bc23ab0f7b35949b853f245cea016c20",
};
